import { useAsyncEffect } from '@xylabs/sdk-react'
import { XyoErc721MetaData } from '@xyo-network/sdk-xyoworld-js'
import { PropsWithChildren, useState } from 'react'

import { useGeotoken } from '../Geotoken'
import { Erc721MetaDataContext } from './Context'

interface Props {
  enabled?: boolean
}

export const Erc721MetaDataLoader: React.FC<PropsWithChildren<Props>> = (props) => {
  const geotoken = useGeotoken()
  const { enabled = true } = props

  const [erc721MetaData, setErc721MetaData] = useState<XyoErc721MetaData>()

  useAsyncEffect(
    // eslint-disable-next-line react-hooks/exhaustive-deps
    async (isMounted) => {
      if (geotoken && enabled) {
        const erc721MetaData = await geotoken.getErc721MetaData()
        if (!isMounted()) return
        setErc721MetaData(erc721MetaData)
      }
    },
    [geotoken, enabled],
  )

  return <Erc721MetaDataContext.Provider value={{ ...erc721MetaData?.toJsonObject() }}>{props.children}</Erc721MetaDataContext.Provider>
}
